import 'app/Window'

import { CustomerPreferenceContextProvider, QuoteServiceContextProvider } from 'features/BookingFlow'
import {
  CurrencyConversionQueryClientProvider,
  CurrencyConversionRatesDataLoaderProvider,
  LocalCurrencyContextProvider,
} from 'features/CurrencyConversion'
import { DocumentTypeContextProvider } from 'features/Documents'
import { SFormProvider, ShipUserPreferenceContextProvider } from 'features/Settings'
import { Provider } from 'mobx-react'
import { Component } from 'react'
import { Router } from 'react-router-dom'
import { LastLocationProvider } from 'react-router-last-location'
import { AnalyticsService } from 'service/AnalyticsService'
import { history } from 'service/history'
import { RootStore } from 'service/RootStore'
import { AnalyticsContext } from 'service/useAnalytics'
import { APIContext } from 'service/useApi'
import { AuthContext } from 'service/useAuth'
import { RootStoreContext } from 'service/useRootStore'
import { UIContext } from 'service/useUIStore'
import { UnleashFeatureFlagsContextProvider } from 'service/useUnleashFeatureFlags'
import { LocalisationContext } from 'utils/localisation'
import { logError } from 'utils/logger'
import { initRumWithDefaults } from 'utils/Rum'

import { config } from './config'
import { AppLayout } from './Layout/AppLayout'
import { SilhouetteLocalizationProvider, SilhouetteProvider } from './silhouette'

export class App extends Component {
  rootStore: RootStore
  constructor(props) {
    super(props)
    initRumWithDefaults()
    this.rootStore = new RootStore({
      history,
      analyticsService: new AnalyticsService(config.FULLSTORY_ANALYTICS_ID),
    })
    window.app = this.rootStore
  }

  render() {
    const mobxInjections = { ...this.rootStore, handleReactCatch: logError }

    return (
      <SilhouetteProvider>
        <SFormProvider transformer={this.rootStore.localisationStore.translate}>
          <Provider {...mobxInjections}>
            <RootStoreContext.Provider value={this.rootStore}>
              <APIContext.Provider value={this.rootStore.API}>
                <UIContext.Provider value={this.rootStore.uiStore}>
                  <AuthContext.Provider value={this.rootStore.authStore}>
                    <CustomerPreferenceContextProvider>
                      <LocalisationContext.Provider value={this.rootStore.localisationStore}>
                        <SilhouetteLocalizationProvider>
                          <AnalyticsContext.Provider value={this.rootStore.analyticsService}>
                            {/* @ts-expect-error Fix after migration to react-router-dom v6 */}
                            <Router history={history}>
                              <LastLocationProvider>
                                <UnleashFeatureFlagsContextProvider>
                                  <DocumentTypeContextProvider>
                                    <CurrencyConversionRatesDataLoaderProvider>
                                      <CurrencyConversionQueryClientProvider>
                                        <LocalCurrencyContextProvider>
                                          <QuoteServiceContextProvider>
                                            <ShipUserPreferenceContextProvider>
                                              <AppLayout />
                                            </ShipUserPreferenceContextProvider>
                                          </QuoteServiceContextProvider>
                                        </LocalCurrencyContextProvider>
                                      </CurrencyConversionQueryClientProvider>
                                    </CurrencyConversionRatesDataLoaderProvider>
                                  </DocumentTypeContextProvider>
                                </UnleashFeatureFlagsContextProvider>
                              </LastLocationProvider>
                            </Router>
                          </AnalyticsContext.Provider>
                        </SilhouetteLocalizationProvider>
                      </LocalisationContext.Provider>
                    </CustomerPreferenceContextProvider>
                  </AuthContext.Provider>
                </UIContext.Provider>
              </APIContext.Provider>
            </RootStoreContext.Provider>
          </Provider>
        </SFormProvider>
      </SilhouetteProvider>
    )
  }
}
